import axios from 'axios'
import { BASE_API_URL, BASE_ENTRIES_URL, BASE_FPL_URL } from 'constants/api'

export const pingBackend = (): void => {
  axios.get(`${BASE_API_URL}/health`).catch(() => {/* fire-and-forget */})
}

export interface EntrySearchResult {
  entry: number
  entry_name: string
  player_name: string
}

export const isMongoUnavailableError = (e: unknown): boolean =>
  typeof e === 'object' &&
  e !== null &&
  'response' in e &&
  (e as { response?: { status?: number; data?: { detail?: string } } }).response?.status === 503 &&
  (e as { response?: { data?: { detail?: string } } }).response?.data?.detail === 'mongo_unavailable'

export const getTeamData = async (teamID: number, signal?: AbortSignal) => {
    const response = await axios.get(`${BASE_ENTRIES_URL}/${teamID}`, { signal })
    return response.data
}

export const searchByName = async (name: string, signal?: AbortSignal): Promise<EntrySearchResult[]> => {
  const response = await axios.get<EntrySearchResult[]>(`${BASE_FPL_URL}/search-by-name`, { params: { name }, signal })
  return response.data
}

export const getLeagueEntries = async (leagueId: number): Promise<EntrySearchResult[]> => {
  const response = await axios.get<EntrySearchResult[]>(`${BASE_FPL_URL}/league-entries/${leagueId}`)
  return response.data
}
